if($('.cta-button').length){
    $(window).scroll(function(){
        if($(this).scrollTop() > 300){
            $('.cta-button').addClass('cta-button--scrolled');
        } else{
            $('.cta-button').removeClass('cta-button--scrolled');
        }
    });
}
